function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useContext } from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { Body, Container, Heading, PlatformIcon } from '../../atoms';
import { useAccentColors } from '../../hooks';
import ReactConfigContext from '../../ReactConfigContext';
export default function ResearchPlatformHero(param) {
    var title = param.title, image = param.image, name = param.name, description = param.description, actions = param.actions, socialActions = param.socialActions, _param_accentColor = param.accentColor, accentColor = _param_accentColor === void 0 ? '--colors-blue-500' : _param_accentColor, className = param.className;
    var _image_sizes;
    var _useContext = useContext(ReactConfigContext), _useContext_config = _useContext.config, LinkComponent = _useContext_config.LinkComponent, ImageComponent = _useContext_config.ImageComponent;
    var accentStyle = useAccentColors([
        'colors-research-platform-hero-fg-accent',
        accentColor
    ]);
    return /*#__PURE__*/ React.createElement(Container, {
        name: ResearchPlatformHero.name,
        style: accentStyle,
        className: className
    }, !!title && /*#__PURE__*/ React.createElement("div", {
        className: "text-center mb-9 md:mb-11"
    }, /*#__PURE__*/ React.createElement(Heading, {
        as: "h1",
        variant: "h1"
    }, title)), /*#__PURE__*/ React.createElement("div", {
        className: "bg-bg-subtle rounded-xl p-6 md:p-7"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-5 md:gap-6 md:grid-cols-[1fr_1fr_auto] lg:gap-9"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex justify-start items-center"
    }, !!image && /*#__PURE__*/ React.createElement("div", {
        className: "shrink-0 grow-0 mr-3"
    }, /*#__PURE__*/ React.createElement(ImageComponent, _object_spread_props(_object_spread({}, image), {
        sizes: (_image_sizes = image.sizes) !== null && _image_sizes !== void 0 ? _image_sizes : '160px',
        className: twMerge('w-[5.375rem] h-[5.375rem] rounded-full object-cover object-center block', image.className)
    }))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Heading, {
        as: "h3",
        variant: "h3",
        className: "font-body font-normal text-[var(--colors-research-platform-hero-fg-accent)]"
    }, name), !!description && /*#__PURE__*/ React.createElement(Body, {
        variant: "sm",
        className: "font-semibold whitespace-pre-line mt-3"
    }, description))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-3"
    }, actions === null || actions === void 0 ? void 0 : actions.map(function(action) {
        return /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({
            key: action.href
        }, action), {
            className: "text-link-small font-body font-semibold text-[var(--colors-research-platform-hero-fg-accent)] underline"
        }), action.label);
    }))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-rows-1 auto-cols-max grid-flow-col gap-4 md:gap-6"
    }, socialActions === null || socialActions === void 0 ? void 0 : socialActions.map(function(action) {
        return /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({
            key: action.href
        }, action), {
            className: "text-[var(--colors-research-platform-hero-fg-accent)]"
        }), /*#__PURE__*/ React.createElement(PlatformIcon, {
            type: action.platform
        }));
    }))))));
}

//# sourceMappingURL=ResearchPlatformHero.js.map